import { accountNumberValidationRegex, addressValidationRegex, bankBranchValidationRegex, emailValidationRegex, ifscValidationRegex, beneficiaryNameRegex, phoneNumberValidationRegex } from "../app_methods";
import { get, post, put } from "../services/HttpService";


export class Merchant {
    constructor(merchantObject = {}) {
        this.set(merchantObject);
    };

    static validations = {
        "id": [],
        "created_at": [],
        "name": [
            { required: true, message: "Name is required." },
            { pattern: /^[A-Za-z0-9 ]*$/, message: "Please enter a valid name." },
            { min: 1, message: "Must be at least 1 character long" },
            { max: 100, message: "Can be of maximum 100 characters" }
        ],
        "password": [
            { required: true, message: "Password is required." }
        ],
        "email": [
            { required: true, message: "Email ID is required." },
            { pattern: emailValidationRegex(), message: "Please enter a valid Email ID." }
        ],
        "phone": [
            { required: true, message: "Phone is required." },
            { pattern: phoneNumberValidationRegex(), message: "Phone number is invalid." }
        ],
        "state": [
            { pattern: '^[A-Za-z & ]+$', message: "Please enter a valid state" },
        ],
        "business_name": [
            { required: true, message: "Business Name is required." },
            { pattern: beneficiaryNameRegex(), message: "Please enter a valid name." },
            { min: 1, message: "Must be at least 1 character long" },
            { max: 250, message: "Can be of maximum 250 characters" }
        ],
        "nature_of_business": [
            { required: true, message: "Business Type is required." },
        ],
        "entity_type": [
            { required: true, message: "Business Type is required." },
        ],
        "business_address": [
            { pattern: addressValidationRegex(), message: "Please enter a valid details" },
        ],
        "gstin": [
            { pattern: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/, message: "GSTIN format is invalid." }
        ],
        "name_on_bank": [
            { required: true, message: "Name is required." },
            { pattern: beneficiaryNameRegex(), message: "Please enter a valid Name." },
        ],
        "bank_name": [
            { required: true, message: "Bank Name is required." },
            { pattern: beneficiaryNameRegex(), message: "Please enter a valid bank name." },
        ],
        "bank_branch": [
            { required: true, message: "Bank Branch is required." },
            { pattern: bankBranchValidationRegex(), message: "Please enter a valid bank branch name." },
        ],
        "account_number": [
            { required: true, message: "Account Number is required." },
            { pattern: accountNumberValidationRegex(), message: "Please enter a valid account number." },
            { min: 3, message: "Must be atleast 3 characters long." },
            { max: 20, message: "Can be of maximum 20 characters." },
        ],
        "account_ifsc": [
            { required: true, message: "Account IFSC is required." },
            { pattern: ifscValidationRegex(), message: "Please enter a valid IFSC." },
            { len:11, message: "IFSC must be of 11 characters." }
        ],
        "size": [
            { required: true, message: "Size is required." },
        ],
        "genre": [
            { required: true, message: "Genre is required." },
        ],
        "domain": [
            { required: true, message: "Domain is required." },
        ],
        "subdomain": [
            { required: true, message: "Subdomain is required." },
        ],
        "business_type_code": [
            { required: true, message: "Business Type Code is required." },
        ],
    };

    /**
     * @memberof Merchant
     * @type API
     * @returns Promise
     */
    static list = (queryData = {}, config = {}) => {
        return get(`v1/internal/merchants/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }));
    };
    
    /**
     * @memberof Merchant
     * @type API
     * @returns Promise
     */
    static list_v2 = (queryData = {}, config = {}) => {
        return get(`v2/internal/merchants/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }));
    };

    list_virtual_accounts = () => {
        return get(`v1/internal/merchants/${this.id}/virtual_accounts/`, {}, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    static wallet_account_statetment = (queryData = {}, config = {}) => {
        return get(`v1/internal/wallet/account_statement/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }));
    };

    /**
     * @memberof Merchant
     * @type API
     * @returns Promise
     */
     static entity_type_list = (queryData = {}, config = {}) => {
        return get(`v1/internal/kyc/entity_types/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }));
    };

    /**
     * @memberof Merchant
     * @type API
     * @returns Promise
     */
    save = () => {
        let queryData = this.get();
        if (queryData.id) return put(`v1/internal/merchants/${this.id}/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
        return post(`v1/internal/merchants/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof Merchant
     * @type API
     * @returns Promise
     */
    update_commission = (queryData) => {
        return put(`v1/internal/merchants/${this.id}/commission/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof Merchant
     * @type API
     * @returns Promise
     */
    update_insta_commission = (queryData) => {
        return put(`v1/internal/merchants/${this.id}/insta_commission/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };
    /**
     * @memberof Merchant
     * @type API
     * @returns Promise
     */
    send_password = () => {
        return post(`v1/internal/merchants/${this.id}/send_password/`, {}, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof Merchant
     * @type API
     * @returns Promise
     */
    upload_kyc = (queryData) => {
        let formData = new FormData();
        formData.append("id_proof_file", queryData.id_proof_file && queryData.id_proof_file.file ? queryData.id_proof_file.file : null);
        formData.append("cancelled_cheque_file", queryData.cancelled_cheque_file && queryData.cancelled_cheque_file.file ? queryData.cancelled_cheque_file.file : null);
        formData.append("other_doc_file", queryData.other_doc_file && queryData.other_doc_file.file ? queryData.other_doc_file.file : null);
        formData.append("key", queryData.key);
        return post(`v1/internal/merchants/${this.id}/kyc/`, formData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof Merchant
     * @type API
     * @returns Promise
     */
     get_kyc_url = (queryData) => {
        return get(`v1/internal/merchants/${this.id}/kyc/signed_url/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

      /**
     * @memberof Merchant
     * @type API
     * @returns Promise
     */
       get_merchant_kyc_url = (queryData) => {
        
        return get(`v1/internal/authentications/kyc/signed_url/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof Merchant
     * @type API
     * @returns Promise
     */
    get_kyc_data = (queryData) => {
        return get(`v1/internal/merchants/${this.id}/kyc/get_data/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    }

    /**
     * @memberof Merchant
     * @type API
     * @returns Promise
     */
    change_password = (queryData) => {
        return post(`v1/internal/merchants/${this.id}/password/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof Merchant
     * @type API
     * @returns Promise
     */
    get_insights = (queryData) => {
        return get(`v1/internal/merchants/${this.id}/insights/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    initiate_pg_payment = (queryData) => {
        return post(`v1/internal/pg_transactions/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    }

    update_pg_payment = (queryData) => {
        return put(`v1/internal/pg_transactions/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    }

    view_pg_transaction_history = (queryData = {}, config = {}) => {
        return get(`v1/internal/pg_transactions/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    }

    static deactivate_merchant = (queryData = {}, config = {}) => {
        return post(`v1/internal/merchants/deactivate/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    }

    static get_alloted_accounts = (merchantId, queryData = {}, config = {}) => {
        return get(`v1/internal/shared_connected_banking/${merchantId}`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    }

    static create_account = (queryData = {}, config = {}) => {
        return post(`v1/internal/shared_connected_banking/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    }

    static load_amount = (queryData = {}, config = {}) => {
        return post(`v1/internal/shared_connected_banking/manage_funds/${queryData.account_id}/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    }
    static deactivateAccount = (queryData = {}, config = {}) => {
        return post(`v1/internal/shared_connected_banking/deactivate/${queryData.account_id}/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    }
    static update_label = (queryData = {}, config = {}) => {
        return post(`v1/internal/shared_connected_banking/update_label/${queryData.account_id}/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    }
    /**
     * @memberof Merchant
     * @type Getter Method
     * @takes void
     * @returns Merchant Params
     */
    get = () => {
        return {
            id: this.id,
            name: this.name,
            email: this.email,
            phone: this.phone,
            state: this.state,
            business_name: this.business_name,
            nature_of_business: this.nature_of_business,
            business_address: this.business_address,
            gstin: this.gstin,
            bank_name: this.bank_name,
            bank_branch: this.bank_branch,
            account_number: this.account_number,
            account_ifsc: this.account_ifsc,
            entity_type: this.entity_type,
            name_on_bank: this.name_on_bank,
            domain: this.domain,
            subdomain: this.subdomain,
            size: this.size,
            genre: this.genre,
            business_type_code: this.business_type_code
        }
    };

    /**
     * @memberof Merchant
     * @type Setter Method
     * @takes Merchant Params
     * @returns void
     */
    set = (values) => {
        Object.keys(values).forEach(x => this[x] = values[x]);
    };

    /**
     * @memberof Merchant
     * @type Setter Method
     * @takes Merchant Params
     * @returns void
     */
    reset = () => {
        this.id = undefined;
        this.name = undefined;
        this.email = undefined;
        this.phone = undefined;
        this.state = undefined;
        this.business_name = undefined;
        this.nature_of_business = undefined;
        this.entity_type = undefined;
        this.business_address = undefined;
        this.gstin = undefined;
        this.bank_name = undefined;
        this.bank_branch = undefined;
        this.account_number = undefined;
        this.account_ifs = undefined;
        this.name_on_bank = undefined;
        this.domain = undefined;
        this.subdomian = undefined;
        this.size = undefined;
        this.genre = undefined;
        this.business_type_code = undefined;
    };
}